<template>
<div style="width: 100%; height: 100%">
  <div
    ref="duibifenxiangbi"
    v-if="fenxiangData"
    id="duibifenxiangbi"
    style="width: 100%; height: 100%"
  ></div>
  <no-data-temporarily style="width:100%;height: 100%;" v-else></no-data-temporarily>
</div>
</template>

<script>
import { initResizeListener } from '@/utils/utils';
import NoDataTemporarily from '@/components/utils/no-data-temporarily.vue';
import { GetDianNengXiaoHaoForBarChart } from '../../../api/enery-analysis/eneryanalysis';

export default {
  data() {
    return {
      fenxiangData: null,
      dimensions: null,
      source: null,
      series: null,
    };
  },
  components: {
    NoDataTemporarily,
  },
  props: {
    proId: String,
    selectPeriod: Array,
    periodType: String,
  },
  watch: {
    fenxiangData() {
      this.$nextTick(this.initData);
    },
    selectPeriod() {
      this.requestData();
    },
    proId() {
      this.requestData();
    },
    skinType() {
      this.initData();
    },
  },
  created() {
    this.requestData();
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    // 初始化数据
    requestData() {
      if (!this.proId) {
        return;
      }
      const [start, end] = this.selectPeriod;
      GetDianNengXiaoHaoForBarChart({
        StationIdStr: this.proId,
        DateType: this.periodType,
        BeginDate: start,
        EndDate: end,
      })
        .then((res) => {
          this.fenxiangData = res.fenxiangData;
          this.dimensions = res.fenxiangData.dimensions;
          this.source = res.fenxiangData.source;
          this.series = [];
          this.dimensions.forEach((itme) => {
            if (itme !== 'product') {
              const itemData = {
                type: 'bar',
                stack: 'Ad',
                barMaxWidth: 20,
                // lineStyle: {
                //   width: 2,
                // },
              };
              this.series.push(itemData);
            }
          });
        }).catch(() => {
          this.fenxiangData = null;
          this.dimensions = null;
          this.source = null;
        });
    },
    initResizeListener(chart) {
      const resizeObserver = new ResizeObserver(() => {
        // 回调
        chart.resize();
      });
      // 监听对应的dom
      resizeObserver.observe(this.$refs.duibifenxiangbi);
    },
    initData() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = this.$echarts.init(document.getElementById('duibifenxiangbi'));
      // 绘制图表
      myChart.setOption({
        color: this.skinType
          ? ['#FFAF8E', '#667EEB', '#75B2FB', '#08BED3', '#F67CA3', '#7FC4C2', '#D891FF', '#79ACFF', '#5CD4D2', '#63D19F', '#FF9E48', '#FF8A73', '#A1D759', '#61C9E7', '#008CDB', '#E1D7FA']
          : [
            '#FFAF8E',
            '#667EEB',
            '#75B2FB',
            '#08BED3',
            '#F67CA3',
            '#7FC4C2',
            '#7a81b5'],
        grid: {
          bottom: 0,
          left: 130,
          right: 20,
          top: 30,
          barBorderRadius: 28,
          containLabel: true,
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          top: 0,
          left: 0,
          textStyle: {
            color: 'auto',
          },
          itemWidth: 16,
          itemHeight: 10,
          itemGap: 5,
          pageIconColor: '#409EFF',
          pageIconSize: 10,
          pageTextStyle: {
            color: '#409EFF',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          textStyle: {
            align: 'left',
          },
        },
        toolbox: {
          show: true,
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
            restore: { show: true },
            saveAsImage: { show: true },
          },
          iconStyle: {
            color: '#fff',
            borderColor: '#fff',
            shadowColor: '#fff',
          },
        },
        dataset: {
          dimensions: this.dimensions,
          source: this.source,
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: this.skinType ? '#fff' : '#333',
          },
          axisLine: {
            color: this.skinType ? '#fff' : '#333',
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            color: this.skinType ? '#fff' : '#333',
          },
          axisLabel: {
            color: this.skinType ? '#fff' : '#333',
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#ccc',
            },
          },
        },
        series: this.series,
      }, true);
      myChart.on('click', (_params) => {
        console.log(_params);
        this.params = _params;
        // 发起请求 请求
        const dtBegin = _params.name;
        const strFenxiang = _params.seriesName;
        this.FunShowSankey({
          StationIdStr: this.proId,
          DateType: this.periodType,
          BeginDate: dtBegin,
          EndDate: dtBegin,
          FenQvName: '',
          FenXiangName: strFenxiang,
          IsMix: true,
          color: _params.color,
        });
      });
      initResizeListener(myChart, this.$refs.duibifenxiangbi);
    },
    FunShowSankey(data) {
      this.$emit('FunShowSankey', data);
    },
  },
};
</script>
<style scoped>
.pie {
  position: relative;
  /* top: 0.1vh; */
  /* background-color: #fa7844; */
}
</style>
